<template>
    <div>
        <b-row>
            <b-col cols="12">
                <b-card class="mb-3" title="Kitap Listesi">
                    <b-alert variant="warning" show class="mb-0">
                        <div class="alert-body mb-2">
                            <!-- <span><strong>Not:</strong> Eklenecek podcast adı ve arama motoru
                  bağlantı linki benzersiz olmalıdır...</span> -->
                        </div>
                    </b-alert>
                    <b-button class="float-right" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary"
                        :to="`/galleries/create`">
                        Yeni Galeri Ekle
                    </b-button>
                </b-card>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <b-card class="mb-3" title="Galeriler">
                    <b-form>
                        <b-row>
                            <b-col cols="12">
                                <table class="table b-table table-responsive">
                                    <thead>
                                        <th>#</th>
                                        <th>KATEGORİ</th>
                                        <th>BAŞLIK</th>
                                        <th>GÖRSEL SAYISI</th>
                                        <th>TARİH</th>
                                        <!-- <th>ÖNİZLEME</th> -->
                                        <th>İŞLEMLER</th>
                                    </thead>
                                    <draggable v-model="galleries" class="cursor-move" tag="tbody" @change="outputData">
                                        <tr v-for="gallery in galleries" :key="gallery.id">
                                            <td>{{ gallery.id }}</td>
                                            <td>{{ gallery.galleryCategory.name }}</td>
                                            <td>{{ gallery.title }}</td>
                                            <td>{{ gallery.galleryImages.length }}</td>
                                            <td>{{ gallery.createdAt }}</td>
                                            <!-- <td>
                                                <b-button-group>
                                                    <b-button title="Önizleme"
                                                        @click="actionPreview(gallery, $i18n.locale)"
                                                        variant="outline-primary">
                                                        Önizleme
                                                    </b-button>
                                                </b-button-group>
                                            </td> -->
                                            <td>
                                                <b-button-group class="float-right">
                                                    <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                                        variant="outline-danger" class="btn-icon rounded-circle"
                                                        @click="deleteConfirmText(gallery.id)">
                                                        <feather-icon icon="TrashIcon" />
                                                    </b-button>
                                                </b-button-group>
                                                <b-button-group class="float-right mr-2">
                                                    <b-button v-for="language in languages" :key="language.locale"
                                                        @click="action(gallery, language.locale)"
                                                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                                        :variant="gallery.languages.find((element) => element == language.locale) ? 'outline-warning' : 'outline-secondary'"
                                                        :title="gallery.languages.find((element) => element == language.locale) ? 'Düzenle' : 'Ekle'">
                                                        {{ language.locale.toUpperCase() }}
                                                    </b-button>
                                                </b-button-group>
                                            </td>
                                        </tr>
                                    </draggable>
                                    <thead>
                                        <th>#</th>
                                        <th>KATEGORİ</th>
                                        <th>BAŞLIK</th>
                                        <th>GÖRSEL SAYISI</th>
                                        <th>TARİH</th>
                                        <!-- <th>ÖNİZLEME</th> -->
                                        <th>İŞLEMLER</th>
                                    </thead>
                                </table>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import Ripple from "vue-ripple-directive";
import draggable from "vuedraggable";
import {
    BRow,
    BCol,
    BImg,
    BCard,
    BForm,
    BBadge,
    BAlert,
    BButton,
    BAvatar,
    BCardText,
    BButtonGroup,
    BListGroupItem,
    BButtonToolbar,

} from "bootstrap-vue";
import settings from '../../../settings';
import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();

export default {
    components: {
        BRow,
        BCol,
        BImg,
        BCard,
        BForm,
        BBadge,
        BAlert,
        BButton,
        BAvatar,
        BCardText,
        BButtonGroup,
        BListGroupItem,
        BButtonToolbar,
        draggable,
    },
    directives: {
        Ripple,
    },
    data() {
        return {
            request: [],
            galleries: [],
            languages: []
        };
    },
    watch: {},
    methods: {
        action(node, locale) {
            let translationControl = node.languages.find(
                (element) => element == locale
            );
            if (translationControl == undefined) {
                this.$router.push({
                    path: `/galleries/create/translation/${node.slugs}?targetLocale=${locale}`,
                });
            } else {
                this.$router.push({
                    path: `/galleries/edit/${node.slugs[locale]}?targetLocale=${locale}`,
                });
            }
        },
        actionPreview(node, locale) {
            let translationControl = node.languages.find(
                (element) => element == locale
            );
            if (translationControl == undefined) {
            } else {
                // window.open(`${settings.uiBaseUrl}/contents/preview/${node.slugs[locale]}?hl=${locale}`, '_blank');
                window.open(`${settings.uiBaseUrl}/galleries/${node.slug}?hl=${locale}`, '_blank');
            }
        },
        outputData() {
            this.updateSubmit();
        },
        updateSubmit() {
            Object.entries(this.galleries).forEach(([key, value]) => {
                let galleriesOrder = {
                    slug: value.slug,
                    order: parseInt(key),
                };
                this.request.push(galleriesOrder);
            });
            endpoints
                .putGalleriesOrder(
                    { galleries: this.request },
                    this.$i18n.locale,
                    () => { }
                )
                .then((data) => {
                    this.$swal({
                        icon: "success",
                        title: "Güncelleme başarılı!",
                        text: "Galeri sıralaması güncellendi.",
                        customClass: {
                            confirmButton: "btn btn-success",
                        },
                    });
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        getLanguages() {
            endpoints
                .getLanguages(null, this.$i18n.locale, () => { })
                .then((data) => {
                    this.languages = [...data.response];
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        getGalleries() {
            endpoints
                .getGalleries(
                    null,
                    this.$i18n.locale,
                    () => { }
                )
                .then((data) => {
                    this.galleries = [];
                    this.galleries = [...data.response];
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        deleteConfirmText(id) {
            this.$swal({
                title: "Sil?",
                text: "Galeriyi istediğinize emin misiniz?",
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: "Vazgeç!",
                confirmButtonText: "Kaydet!",
                customClass: {
                    confirmButton: "btn btn-primary",
                    cancelButton: "btn btn-outline-danger ml-1",
                },
                buttonsStyling: false,
            }).then((result) => {
                if (result.value) {
                    this.deleteSubmit(id);
                }
            });
        },
        deleteSubmit(id) {
            endpoints
                .deleteGalleries(id, this.$i18n.locale, () => { })
                .then((data) => {
                    this.getGalleries();
                    this.$swal({
                        icon: "success",
                        title: "Silme başarılı!",
                        text: "Galeri silindi",
                        customClass: {
                            confirmButton: "btn btn-success",
                        },
                    });
                })
                .catch((err) => {
                    console.log(err);
                });
        },
    },
    mounted() {
        this.getLanguages();
        this.getGalleries();
    },
};
</script>
<style>
.draggable-card {
    margin-bottom: 0;
}

.draggable-card>.card-body {
    padding: 10px;
}

.draggable-card>.card-body>.card-title {
    margin-bottom: 0;
    font-size: 1rem;
}

.tree-node {
    border: 0 !important;
}
</style>
  